import { Container } from 'theme-ui';

import { withInView } from '@utils';
import { Section } from '@snippets';

import { Schema } from './ThreeTile.schema';
import { Slider, GridDisplay } from './Displays';
import { Header, Footer } from './Content';

export const ThreeTile = withInView(
  ({ cms }) => {
    const { section, header, tiles, tile } = cms;

    return (
      <Section section={section} sx={{ overflow: 'hidden' }}>
        <Container data-comp={ThreeTile.displayName}>
          <Header
            header={header}
            section={section}
            style={{
              paddingRight: tile?.display === 'stacked' ? '0' : [0, '100px'],
            }}
          />

          {tiles?.length > 0 ? (
            tile?.display === 'stacked' ? (
              <GridDisplay tiles={tiles} tile={tile} />
            ) : (
              <Slider tiles={tiles} tile={tile} />
            )
          ) : null}

          <Footer header={header} section={section} />
        </Container>
      </Section>
    );
  },
  { triggerOnce: true }
);

ThreeTile.displayName = 'ThreeTile';
ThreeTile.Schema = Schema;
